import { useMemo } from 'react';

import { useContentfulContentTypeEntry } from '@order/Contentful';

export const useSweetpassCheckoutContentfulData = () => {
  const { data: contentfulData, fetching: isLoading } =
    useContentfulContentTypeEntry<ContentfulSweetpassCheckoutPage>({
      contentType: CONTENT_TYPE,
      include: 2,
    });

  const content = useMemo(() => {
    return { termsAndConditions: contentfulData?.fields?.termsAndConditions };
  }, [contentfulData?.fields?.termsAndConditions]);

  return { content, isLoading };
};

type ContentfulSweetpassCheckoutPage = {
  readonly termsAndConditions: string;
};

const CONTENT_TYPE = 'sweetpassCheckoutPage';
